<template>
  <div>
    <!-- Navegação por Abas -->
    <div class="row">
      <div class="col-md-12">
        <ul class="nav nav-tabs" id="homeTabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button 
              :class="['nav-link', { active: isTabActive('dashboard') }]"
              @click="switchTab('dashboard')"
              type="button" 
              role="tab"
            >
              <i class="fas fa-chart-bar"></i> Dashboard
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button 
              :class="['nav-link', { active: isTabActive('schedule') }]"
              @click="switchTab('schedule')"
              type="button" 
              role="tab"
            >
              <i class="fas fa-calendar-alt"></i> Painel de Agendamentos
            </button>
          </li>
        </ul>
      </div>
    </div>

    <!-- Conteúdo das Abas -->
    <div class="" id="homeTabsContent">
      <!-- Aba Dashboard -->
      <div v-show="isTabActive('dashboard')" class="tab-pane" id="dashboard" role="tabpanel">
        <Dashboard />
      </div>
      
      <!-- Aba Painel de Agendamentos -->
      <div v-show="isTabActive('schedule')" class="tab-pane" id="schedule" role="tabpanel">
        <div class="row">
          <div class="col-md-12">
            <SchedulePanel 
              :bookings="scheduleBookings" 
              :rooms="scheduleRooms"
              :companies="companies"
              :branches="branches"
              @filters-changed="onScheduleFiltersChanged"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dashboard from "@/components/Dashboard.vue";
import SchedulePanel from "@/components/Utils/SchedulePanel.vue";

export default {
  name: 'Home',
  data() {
    return {
      activeTab: 'dashboard', // Controla qual aba está ativa
      // Dados para o painel de agendamentos
      scheduleBookings: [],
      scheduleRooms: [],
      scheduleDates: [],
      companies: [],
      branches: [],
    };
  },
  methods: {
    // Métodos para controle das abas
    switchTab: function(tabName) {
      this.activeTab = tabName;
      
      // Se mudou para a aba de agendamentos, carregar os dados
      if (tabName === 'schedule') {
        this.$nextTick(() => {
          this.getScheduleData();
        });
      }
    },

    isTabActive: function(tabName) {
      return this.activeTab === tabName;
    },

    // Métodos para o painel de agendamentos
    initializeScheduleDates: function() {
      const dates = [];
      const today = new Date();
      for (let i = 0; i < 3; i++) {
        const date = new Date(today);
        date.setDate(today.getDate() + i);
        dates.push(date.toISOString().split('T')[0]);
      }
      this.scheduleDates = dates;
    },

    getScheduleData: function() {
      const self = this;
      const api = self.$store.state.api + "schedule-panel-data";

      let fd = {
        date_start: self.scheduleDates[0] || '',
        date_end: self.scheduleDates[self.scheduleDates.length - 1] || '',
        company: '',
        branch: '',
      };

      self.$http
        .post(api, fd)
        .then((response) => {
          if (response.data && response.data.rooms && response.data.bookings) {
            self.scheduleBookings = response.data.bookings;
            self.scheduleRooms = response.data.rooms;
          } else {
            // Inicializar arrays vazios se não há dados
            self.initializeScheduleData();
          }
        })
        .catch((error) => {
          console.log('Erro ao buscar dados do painel:', error);
          // Inicializar arrays vazios em caso de erro
          self.initializeScheduleData();
        });
    },

    initializeScheduleData: function() {
      // Inicializar arrays vazios - dados virão da API
      this.scheduleRooms = [];
      this.companies = [];
      this.branches = [];
      this.scheduleBookings = [];
    },

    onScheduleFiltersChanged: function(filters) {
      // Buscar novos dados baseado nos filtros
      this.getScheduleDataWithFilters(filters);
    },

    getScheduleDataWithFilters: function(filters) {
      const self = this;
      const api = self.$store.state.api + "schedule-panel-data";

      let fd = {
        date_start: '',
        date_end: '',
        company: filters.company_id || '',
        branch: filters.branch_id || '',
        room_id: filters.room_id || '',
        month_year: filters.month_year || ''
      };

      self.$http
        .post(api, fd)
        .then((response) => {
          if (response.data && response.data.rooms && response.data.bookings) {
            self.scheduleBookings = response.data.bookings;
            self.scheduleRooms = response.data.rooms;
          } else {
            // Inicializar arrays vazios se não há dados
            self.initializeScheduleData();
          }
        })
        .catch((error) => {
          console.log('Erro ao buscar dados do painel:', error);
          // Inicializar arrays vazios em caso de erro
          self.initializeScheduleData();
        });
    },
  },
  components: {
    Dashboard,
    SchedulePanel,
  },
  mounted: function () {
    const self = this;
    self.initializeScheduleDates();
  },
};
</script>

<style scoped>
/* Estilos para as Abas */
.nav-tabs {
  border-bottom: 2px solid #dee2e6;
  margin-bottom: 20px;
}

.nav-tabs .nav-link {
  border: none;
  border-bottom: 3px solid transparent;
  color: #6c757d;
  font-weight: 500;
  padding: 12px 20px;
  transition: all 0.3s ease;
}

.nav-tabs .nav-link:hover {
  border-color: transparent;
  border-bottom-color: #007bff;
  color: #007bff;
  background-color: transparent;
}

.nav-tabs .nav-link.active {
  color: #007bff;
  background-color: transparent;
  border-color: transparent;
  border-bottom-color: #007bff;
  font-weight: 600;
}

.nav-tabs .nav-link i {
  margin-right: 8px;
  font-size: 1.1em;
}

.tab-content {
  padding-top: 0;
}

.tab-pane {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsividade para as abas */
@media (max-width: 768px) {
  .nav-tabs .nav-link {
    padding: 10px 15px;
    font-size: 0.9em;
  }
  
  .nav-tabs .nav-link i {
    margin-right: 5px;
    font-size: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue